"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalysisTablePreferences = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const nmr_load_save_1 = require("nmr-load-save");
const react_1 = require("react");
const fa_1 = require("react-icons/fa");
const Button_1 = __importDefault(require("../../../elements/Button"));
const ReactTable_1 = __importDefault(require("../../../elements/ReactTable/ReactTable"));
const FormikInput_1 = __importDefault(require("../../../elements/formik/FormikInput"));
const inputStyle = { input: { width: '100%', fontSize: '1.15em' } };
function AnalysisTablePreferences() {
    const { values: { analysisOptions: { columns }, }, setFieldValue, } = (0, formik_1.useFormikContext)();
    const addNewColumn = (0, react_1.useCallback)((index, columns) => {
        void setFieldValue('analysisOptions.columns', [
            ...columns,
            {
                tempKey: '',
                type: 'FORMULA',
                valueKey: 'value',
                formula: '',
                index,
            },
        ]);
    }, [setFieldValue]);
    const handleDelete = (0, react_1.useCallback)((index, columns) => {
        void setFieldValue('analysisOptions.columns', columns.filter((_, colIndex) => colIndex !== index));
    }, [setFieldValue]);
    const COLUMNS = (0, react_1.useMemo)(() => {
        return [
            {
                Header: '#',
                accessor: (_, index) => index + 1,
            },
            {
                Header: 'Label',
                Cell: ({ row }) => ((0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: `analysisOptions.columns.${row.index}.tempKey`, style: inputStyle })),
            },
            {
                Header: 'Value',
                Cell: ({ row }) => {
                    const isFormulaColumn = row.original.type === nmr_load_save_1.AnalysisColumnsTypes.FORMULA;
                    return ((0, jsx_runtime_1.jsx)(FormikInput_1.default, { disabled: !isFormulaColumn, name: `analysisOptions.columns.${row.index}.formula`, style: inputStyle }));
                },
            },
            {
                Header: '',
                style: { width: '50px' },
                id: 'add-button',
                Cell: ({ data, row }) => {
                    return ((0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex' }, children: [(0, jsx_runtime_1.jsx)(Button_1.default.Danger, { fill: "outline", onClick: () => handleDelete(row.index, data), children: (0, jsx_runtime_1.jsx)(fa_1.FaTimes, {}) }), data.length === row.index + 1 && ((0, jsx_runtime_1.jsx)(Button_1.default.Done, { fill: "outline", onClick: () => addNewColumn(row.index + 1, data), children: (0, jsx_runtime_1.jsx)(fa_1.FaPlus, {}) }))] }));
                },
            },
        ];
    }, [addNewColumn, handleDelete]);
    return (0, jsx_runtime_1.jsx)(ReactTable_1.default, { columns: COLUMNS, data: columns });
}
exports.AnalysisTablePreferences = AnalysisTablePreferences;
